import {Component, computed, input, ChangeDetectionStrategy} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {SeFeHeaderModule} from 'se-fe-header';
import {SeFePageModule} from 'se-fe-page';
import {SeFeTab, SeFeTabsModule} from 'se-fe-tabs';

@Component({
  selector: 'app-commerce-shell',
  templateUrl: './commerce-shell.component.html',
  styleUrl: './commerce-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, SeFeHeaderModule, SeFePageModule, SeFeTabsModule],
})
export class CommerceShellComponent {
  currentOrgId = input.required<string>();

  tabs = computed<SeFeTab[]>(() => {
    const commerceRoute = ['/org', this.currentOrgId(), 'commerce'];

    return [
      {text: 'Products', routerLink: [...commerceRoute, 'products']},
      {text: 'Bundles', routerLink: [...commerceRoute, 'bundles']},
      {text: 'Catalogs', routerLink: [...commerceRoute, 'catalogs']},
    ];
  });
}
